import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../shared/api/supabase';
import { getActiveRun, getScriptVersions, getVersionsBought } from './api';

export const scriptVersionKeys = {
  all: ['script-versions'] as const,
  list: (projectId: string) => ['script-versions', 'list', projectId] as const,
  activeRun: (projectId: string) => ['script-versions', 'active-run', projectId] as const,
  bought: (projectId: string) => ['script-versions', 'bought', projectId] as const,
};

/**
 * The project's versions. A plain query, refetched after an upload or a delete: what the customer sees changes
 * only when staff confirm a version, so nothing polls.
 */
export const useScriptVersions = (projectId: string) =>
  useQuery({
    queryKey: scriptVersionKeys.list(projectId),
    queryFn: () => getScriptVersions(supabase, projectId),
  });

/** Whether a run is active on the project, refetched with the versions. */
export const useActiveRun = (projectId: string) =>
  useQuery({
    queryKey: scriptVersionKeys.activeRun(projectId),
    queryFn: () => getActiveRun(supabase, projectId),
  });

/** The versions the placed orders bought. */
export const useVersionsBought = (projectId: string) =>
  useQuery({
    queryKey: scriptVersionKeys.bought(projectId),
    queryFn: () => getVersionsBought(supabase, projectId),
  });
